import { Ng2StateDeclaration, StateRegistry } from '@uirouter/angular';
import { NotificationCentrePageComponent } from './feature/notification-centre-page/notification-centre-page.component';
import { ProjectWatchPageComponent } from './feature/project-watch-page/project-watch-page.component';

export const notificationCentreStateAngular: Ng2StateDeclaration = {
    parent: 'app',
    name: 'notificationCentre',
    url: '/notificationcentre',
    component: NotificationCentrePageComponent,
    data: { requiresAuth: true }
};

export const projectWatchStateAngular: Ng2StateDeclaration = {
    parent: 'app',
    name: 'projectWatch',
    url: '/projectwatch/:guid/:name?projectID&projectName',
    component: ProjectWatchPageComponent,
    params: {
        projectID: {
            value: null,
            squash: true,
            dynamic: true,
        },
        projectName: {
            value: null,
            squash: true,
            dynamic: true,
        },
    },
    data: { requiresAuth: true }
};

export function registerNotificationStates(
    registry: StateRegistry,
    features: { useNewNotifications: boolean }
): void {
    if (!features.useNewNotifications) {
        return;
    }

    if (!registry.get(notificationCentreStateAngular.name)) {
        registry.register(notificationCentreStateAngular);
    }

    if (!registry.get(projectWatchStateAngular.name)) {
        registry.register(projectWatchStateAngular);
    }

}
